import React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const theme = createTheme({
  typography: {
    body1: {
      fontFamily: '"Roboto", sans-serif',
    },
  },
  components: {
    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: "34px",
          height: "34px",
        },
        indicator: {
          backgroundColor: "#3246d3",
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          // remove default styling on focus
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(0, 0, 0, 0.23)",
            borderWidth: "1px",
          },
        },
        select: {
          paddingLeft: "16px",
          paddingRight: "40px",
        },
        icon: {
          width: "16px !important",
          height: "16px !important",
          fontSize: "16px !important",
          top: "calc(50% - 8px) !important",
        },
      },
      defaultProps: {
        IconComponent: KeyboardArrowDownIcon,
        MenuProps: {
          // make the select dropdown popout bottom left
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left",
          },
          PaperProps: {
            style: {
              minWidth: "180px",
              borderRadius: "12px",
              marginTop: "6px",
              boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.06)",
              border: "1px solid #f1f5f9",
            },
          },
        },
      },
    },

    MuiMenu: {
      styleOverrides: {
        list: {
          padding: "8px",
        },
      },
    },

    MuiMenuItem: {
      styleOverrides: {
        root: {
          padding: "8px",
          borderRadius: "8px",
          color: "#25265e",
          fontWeight: 400,
          fontSize: "14px",
          marginBottom: "2px",
          "&:last-child": { marginBottom: 0 },

          "&, &:hover, &.Mui-focusVisible": {
            color: "#25265e",
          },

          "&:hover": {
            backgroundColor: "#f2f5f8",
          },

          "&.Mui-selected": {
            color: "#3246d3",
            backgroundColor: "transparent",
            fontWeight: 600,

            "&:hover": {
              backgroundColor: "#f1f5f9",
            },
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
          minHeight: "34px",
          height: "34px",
          padding: "0 16px",
          fontSize: "0.85rem",
          color: "inherit",
          "&.Mui-selected": {
            color: "black",
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontFamily: '"Roboto", sans-serif',
          "&.Mui-focused": {
            color: "#3246D3",
          },
        },
      },
    },
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: "#3246D3",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          background: "white",
          "& fieldset": {
            borderRadius: "8px",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#3246D3",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#3246D3",
          },
          "& input::placeholder": {
            fontSize: "14px",
          },
          "& .MuiSelect-select": {
            fontWeight: "500 !important",
            fontSize: "14px",
          },
          "& .MuiSelect-icon": {
            color: "#475569", // Matches your slate text color
            fontSize: "1.25rem", // Fine-tunes the icon scale
            right: "8px", // Aligns the right spacing edge
          },
        },
      },
    },
  },
});

export const withTheme = (WrappedComponent) => {
  return function WithTheme(props) {
    return (
      <ThemeProvider theme={theme}>
        <WrappedComponent {...props} />
      </ThemeProvider>
    );
  };
};
